module.exports = __webpack_public_path__ + "img/contact__server——vi.7fa64fad.png";